export const getActiveAffiliateId = user => {
    if (user.preferences?.affiliates?.activeAffiliateId) {
        return user.preferences?.affiliates?.activeAffiliateId;
    }

    let activeAffiliateId = getDefaultAffiliateIds()[0];

    if (user.affiliations && Object.keys(user.affiliations).length > 0) {
        activeAffiliateId = Object.keys(user.affiliations).find(a => a.enabled);
    }

    return activeAffiliateId;
};

export const getDefaultAffiliates = affiliates => {
    const defaultAffiliateIds = getDefaultAffiliateIds();
    return affiliates.findAll(affiliate => defaultAffiliateIds.find(def => def === affiliate.id));
};

export const getDefaultAffiliateIds = () =>
    // Penly acts as the default affiliate, so there is always atleast one affiliate.
    // Default affiliate ids is a list to support multiple default affiliates in the future.
    ['penly']
;

export const affiliateLocalstorageKey = 'affiliateid';
